var _link, _link2, _style, _style2, _style3, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-custom-link"
  })), _link2 || (_link2 = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-general-link"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-custom-style"
  })), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-style"
  })), _style3 || (_style3 = /*#__PURE__*/React.createElement("style", null, "\n        .line {\n            fill: none;\n            stroke: #aaa;\n            stroke-width: 8;\n            stroke-dasharray: 40;\n        }\n\n        .animated {\n            animation: draw 0.8s ease-in-out;\n            animation-iteration-count: infinite;\n            stroke-dashoffset: 0;\n        }\n\n        .line2 {\n            animation-delay: 0.08s\n        }\n\n        .line3 {\n            animation-delay: 0.16s\n        }\n\n        @keyframes draw {\n            0% {\n                stroke-dashoffset: 0;\n            }\n\n            50% {\n                stroke-dashoffset: 30;\n            }\n\n            100% {\n                stroke-dashoffset: 0;\n            }\n        }\n    ")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "line animated",
    x1: 14,
    y1: 10,
    x2: 14,
    y2: 50
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "line animated line2",
    x1: 30,
    y1: 10,
    x2: 30,
    y2: 50
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "line animated line3",
    x1: 46,
    y1: 10,
    x2: 46,
    y2: 50
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLoading);
export default __webpack_public_path__ + "static/media/cardLoading.b3889c62a1dd8648102c95992f66faf0.svg";
export { ForwardRef as ReactComponent };